module.exports = __webpack_public_path__ + "img/finalize.64ea8300.png";